module.exports = __webpack_public_path__ + "static/media/CompositeMouse.8e694502.png";